import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Top from '@/page/top'
import Index from '@/page/index'
import Maintenance from '@/components/maintenance'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'top',
      component: Top
    },
    {
      path: '/page',
      name: 'Page',
      component: Index,
      children: [{
        path: 'basicMode',
        name: 'BasicMode',
        component: () => import('@/page/mode/basicMode')
      }, {
        path: 'advanceMode',
        name: 'AdvanceMode',
        component: () => import('@/page/mode/advanceMode')
      }]
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: Maintenance
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js